export default __webpack_public_path__ + "static/media/paid.e71323d4.svg";